
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function AlertDetails() {
  const { id } = useParams(); // Get the alert ID from the URL
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAlertDetails = async () => {
      const serverUrl = process.env.REACT_APP_API_SERVER_URL || 'http://10.153.28.40:8080';
      try {
        const res = await axios.get(`${serverUrl}/maiApi/alerts/${id}`);
        setAlert(res.data);
      } catch (err) {
        console.error(`Failed to fetch alert details for ID ${id}:`, err);
        setError("Could not load alert details. Please check the connection.");
      } finally {
        setLoading(false);
      }
    };

    fetchAlertDetails();
  }, [id]); // Re-fetch if the ID changes

  if (loading) return <div className="p-8 text-center text-xl">Loading alert details...</div>;
  if (error) return <div className="p-8 text-center text-red-600 text-xl">{error}</div>;
  if (!alert) return <div className="p-8 text-center text-xl">Alert not found.</div>;

  return (
    <div className="p-8 max-w-4xl mx-auto bg-white shadow-md rounded-lg">
      <h1 className="text-3xl font-bold mb-6 text-center">Alert Details (ID: {alert.id})</h1>
      <div className="space-y-4">
        <p><strong>Alert Type:</strong> {alert.alert_type}</p>
        <p><strong>Yard Name:</strong> {alert.yard_name || 'N/A'}</p>
        <p><strong>Yard Number:</strong> {alert.yard_number || 'N/A'}</p>
        <p><strong>Android ID:</strong> {alert.android_id || 'N/A'}</p>
        <p><strong>Timestamp:</strong> {new Date(alert.date_time).toLocaleString()}</p>
        <p><strong>Details:</strong> {alert.details}</p>
        <p><strong>Status:</strong> {alert.status || 'Active'}</p>
        
      </div>
      <button
        onClick={() => navigate('/alerts')}
        className="mt-8 px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
      >
        Back to All Alerts
      </button>
    </div>
  );
}